<template>
  <!-- 权限历史记录-->
  <el-container class="permission-history pagination-list">
    <el-main>
      <div class="content">
        <div class="log-table">
          <el-table
            class="table-list"
            v-loading="loading"
            height="100%"
            :data="data"
            highlight-current-row>
            <el-table-column
              show-overflow-tooltip
              v-for="column in columns"
              :label="column.label"
              :key="column.prop"
              :prop="column.prop"
              align="center"
            >
            </el-table-column>
            <el-table-column
              label="操作列"
              align="center">
              <template slot-scope="scope">
                <el-button @click="backDialogClick(scope.row)" type="text" size="small">回退</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <el-dialog
        class="permission-history-dialog"
        :visible.sync="dialogVisible"
        width="480px"
        center
        :close-on-click-modal="false"
        :close-on-press-escape="false">
        <div class="permission-history-inline" v-if="!checkBack">
          <el-input v-model="telCode" clearable placeholder="请输入短信验证码" @keydown.native.enter="getTelCode"></el-input>
          <el-button @click="getTelCode">
            <i v-if="loading1" class="el-icon-loading"></i>点击获取验证码</el-button>
        </div>
        <div v-else class="permission-history-center">您确定回退权限吗？</div>
        <div slot="footer" class="dialog-footer" v-if="!checkBack">
          <el-button class="permission-history-button" @click="backClick">确定</el-button>
          <el-button @click="dialogVisible = false;checkBack = false;telCode = '';selectId = ''">取消</el-button>
        </div>
        <div slot="footer" class="dialog-footer" v-else>
          <el-button @click="dialogVisible = false;checkBack = false;telCode = '';selectId = ''">取消</el-button>
          <el-button class="permission-history-button" @click="backClick">
            <i v-if="loading2" class="el-icon-loading"></i>确定</el-button>
        </div>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'permission-history',
  data () {
    return {
      columns: [
        {
          prop: 'title',
          label: '标题'
        }, {
          prop: 'createdTime',
          label: '创建时间'
        }
      ],
      data: [],
      loading: false,
      loading1: false,
      loading2: false,
      dialogVisible: false,
      telCode: '',
      checkBack: false,
      selectId: '',
      userInfo: {
        telephone: '',
        tenantId: '',
        isAdmin: ''
      }
    }
  },
  mounted () {
    this.search()
  },
  methods: {
    search () {
      this.loading = true
      this.$axios.get('/auth-api/authority/history/list').then(res => {
        this.data = res.data
        this.pagination.total = res.data.length
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    backDialogClick (row) {
      this.selectId = row.id
      this.dialogVisible = true
    },
    async getTelCode () {
      this.loading1 = true
      if (!this.userInfo.telephone || !this.userInfo.tenantId) {
        await this.$axios.get('/auth-api/oauth/currentUserInfo').then(res => {
          this.userInfo.telephone = res.data.phone
          this.userInfo.tenantId = res.data.tenantId
          this.userInfo.isAdmin = res.data.admin
        })
      }
      let params = {
        telephone: this.userInfo.telephone,
        tenantId: this.userInfo.tenantId,
        isAdmin: JSON.parse(this.userInfo.isAdmin)
      }
      this.$axios.get(`/auth-api/authority/getTelCode`, {params}).then(res => {
        if (res.data) {
          this.$message({
            message: '验证码发送成功，请注意查收!',
            type: 'success',
            offset: 50
          })
          this.loading1 = false
        }
      }).catch(() => {
        this.loading1 = false
      })
    },
    async backClick () {
      if (this.telCode === '') {
        this.$message({
          message: '请先输入验证码!',
          type: 'warning',
          offset: 50
        })
        return
      }
      if (this.checkBack) {
        // 回退权限
        this.loading2 = true
        if (!this.userInfo.telephone || !this.userInfo.tenantId) {
          await this.$axios.get('/auth-api/oauth/currentUserInfo').then(res => {
            this.userInfo.telephone = res.data.phone
            this.userInfo.tenantId = res.data.tenantId
            this.userInfo.isAdmin = res.data.admin
          })
        }
        this.$axios.post(`/auth-api/authority/back/${this.selectId}?telephone=${this.userInfo.telephone}&tenantId=${this.userInfo.tenantId}&isAdmin=${JSON.parse(this.userInfo.isAdmin)}&telCode=${this.telCode}`).then(() => {
          this.$message({
            message: '权限回退成功!',
            type: 'success',
            offset: 50
          })
          this.loading2 = false
          this.dialogVisible = false
          this.checkBack = false
          this.telCode = ''
        }).catch(() => {
          this.loading2 = false
        })
      } else {
        // 再确认是否回退权限
        this.checkBack = true
      }
    }
  }
}
</script>

<style lang="scss">
  @import '@/assets/scss/common.scss';

  .el-container.permission-history {
    font-size: 12px;
    .log-table{
      height: 100%;
      padding: 0;
      .el-table.table-list{
        border-left: 0;
      }
    }
    .el-main .content .el-input .el-input__inner{
      height: 26px;
      line-height: 26px;
    }
    .permission-history-dialog {
      .el-dialog__header{
        background-color: #fff;
      }
      .el-dialog__body {
        .permission-history-inline {
          padding: 20px 30px 0 30px;
          display: flex;
          justify-content: space-between;
          .el-input {
            width: 200px;
          }
          .el-button {
            background-color: var(--primary, #55ACF1);
            color: #fff;
          }
        }
        .permission-history-center {
          padding: 20px 0 0 0;
          text-align: center;
        }
      }
      .el-dialog__footer>.dialog-footer {
        padding: 0 130px;
        display: flex;
        justify-content: space-between;
        .permission-history-button {
          background-color: var(--primary, #55ACF1);
          color: #fff;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/system/system/permission-history.vue